var _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 620,
    height: 307,
    viewBox: "0 0 620 307",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_444_1433)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65.209,
    cy: -20.847,
    r: 178.209,
    fill: "#523AE7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_444_1433)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 155.5,
    cy: -14.5,
    r: 204.5,
    fill: "#523AE7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_444_1433)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 371,
    cy: 186,
    r: 272,
    fill: "#784EEE"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_444_1433)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 631,
    cy: 51,
    rx: 201,
    ry: 196,
    fill: "#80E2F8"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_444_1433)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 262,
    rx: 210,
    ry: 196,
    fill: "#80E2F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_444_1433",
    x: -333,
    y: -419.056,
    width: 796.418,
    height: 796.418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 110,
    result: "effect1_foregroundBlur_444_1433"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_444_1433",
    x: -179,
    y: -349,
    width: 669,
    height: 669,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 65,
    result: "effect1_foregroundBlur_444_1433"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_444_1433",
    x: -31,
    y: -216,
    width: 804,
    height: 804,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 65,
    result: "effect1_foregroundBlur_444_1433"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_444_1433",
    x: 210,
    y: -365,
    width: 842,
    height: 832,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 110,
    result: "effect1_foregroundBlur_444_1433"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_444_1433",
    x: -414,
    y: -154,
    width: 860,
    height: 832,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 110,
    result: "effect1_foregroundBlur_444_1433"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.a75945fbbcb64f7c9a7ac7f75e95a42f.svg";
export { ForwardRef as ReactComponent };